import axios from 'axios';

import {LoginReturn} from "../types/AuthTypes";
import { getSimulationApiBaseUrl } from "../../../services/getAtlasApiBaseUrl";

const API = getSimulationApiBaseUrl();

// ─── Password Reset ──────────────────────────────────────────────────────────

export async function requestPasswordReset(email: string): Promise<void> {
    await axios.post(`${API}/auth/password-reset`, { email });
}

export interface ResetTokenInfo {
    email: string;
    is_expired: boolean;
}

export async function validateResetToken(token: string): Promise<ResetTokenInfo> {
    const response = await axios.get<ResetTokenInfo>(`${API}/auth/password-reset/${token}`);
    return response.data;
}

export async function submitPasswordReset(token: string, newPassword: string): Promise<void> {
    await axios.post(`${API}/auth/password-reset/${token}/accept`, { new_password: newPassword });
}

// ─── Auth ────────────────────────────────────────────────────────────────────

export async function loginRequest(email: string, password: string): Promise<LoginReturn> {
    const loginUrl = `${API}/auth/token`
    const body = new URLSearchParams();
    body.append('username', email);
    body.append('password', password);

    const response = await axios.post(
        loginUrl,
        body,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
    )

    if (response.status !== 200) {
        return {
            auth_token: '',
            status: 'Login failed, please try again',
            reason: 'Server rejected login attempt'
        }
    }

    const results = {
        auth_token: response.data.access_token,
        status: 'Success',
        reason: ''
    }

    return results
}

export async function registerUserRequest(email: string, password: string, full_name: string) {
    const registerUrl = `${API}/auth/register`

    const formData = {
        email: email,
        password: password,
        full_name: full_name
    };

    const response = await axios.post(
        registerUrl,
        formData,
    )

    if (response.status !== 201 && response.status !== 200) {
        throw new Error('Unexpected error from server - unable to register')
    }

}


